<template>
  <div class="page-deliver-todo">
    <div class="pg-breadcrumb">
      <div class="breadcrumb-item em">澳門門店</div>
      <div class="breadcrumb-item">快遞統計(門店)</div>
    </div>
    <div class="card-block">
      <Form inline class="pg-form-inline">
        <!--<FormItem>
				    <Select size="small" placeholder="提貨櫃點" v-model="form.arrive">
				        <Option :value="item.ReceivingID" v-for="(item, index) in pickAddress"
				                :key="item.ReceivingID">({{item.cainiao_match}}) {{item.ReceivingName}}
				        </Option>
				    </Select>
				</FormItem>-->
        <p style="padding: 12px 0">
          当日实时数据：请用开始时间搜索当日日期提交，历史记录可以用过区间搜索
        </p>
        <FormItem>
          <DatePicker
            type="date"
            size="small"
            placeholder="起始日期"
            :options="options3"
            v-model="form.start_time"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          ></DatePicker>
        </FormItem>
        <FormItem>-</FormItem>
        <FormItem>
          <DatePicker
            type="date"
            size="small"
            placeholder="結束日期"
            :options="options3"
            v-model="form.end_time"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          ></DatePicker>
        </FormItem>
        <FormItem>
          <div class="pg-btn-wrap">
            <div class="pg-btn style1" @click="handleSearch">搜索</div>
            <div class="pg-btn style2" @click="handleExport">导出</div>
          </div>
        </FormItem>
      </Form>
    </div>

    <div class="card-block pd-bt">
      <Spin fix class="pg-sub-loading" v-if="isSubmiting">
        <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
        <div class="loading-text">Loading</div>
      </Spin>

      <Table
        size="small"
        ref="selection"
        border
        @on-selection-change="onSelectionChange"
        no-data-text="暫無數據"
        :columns="table.column"
        :data="table.data"
      >
      </Table>

      <div class="pg-pagger">
        <Row>
          <Col span="11" class="pagger-left">
            <div class="pagger-total mg-r10">總共{{ totalCount }}條記錄</div>
            <div class="pagger-total mg-r10">总件数：{{ totalNumber }}</div>
            <div class="pagger-total mg-r10">總重量：{{ totalWeight }}</div>
          </Col>
          <!--<Col span="13" class="pagger-right">
                        <div>
                            <div class="pagger-sizer">
                                <span>每頁</span>
                                <Select v-model="curPageSize" size="small" placeholder="數量"
                                        @on-change="handlePageSizeChange">
                                    <Option :value="10">10</Option>
                                    <Option :value="20">20</Option>
                                    <Option :value="30">30</Option>
                                    <Option :value="40">40</Option>
                                    <Option :value="50">50</Option>
                                </Select>
                            </div>

                            <div class="pagger-elevator">
                                <span>跳轉</span>
                                <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                                       @on-enter="handlePageEnter"/>
                            </div>

                            <Page size="small"
                                  :current="pageIndex"
                                  :page-size="curPageSize"
                                  :total="totalCount"
                                  @on-change="handlePageChange">
                            </Page>
                        </div>
                    </Col>-->
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Store from "../../../assets/js/store.js";
export default {
  data() {
    return {
      pageIndex: 1, //页码
      curPageSize: 10, //一页数量
      totalCount: 1, //总条数
      pageInput: "", //输入的页码
      pickAddress: [], //提貨櫃點
      form: {
        arrive: Store.fetch().store_id,
        start_time: "",
        end_time: "",
      },
      isSubmiting: false,
      totalNumber: 0,
      totalWeight: 0,
      options3: {
        disabledDate(date) {
          return date && date.valueOf() > Date.now();
        },
      },
      table: {
        column: [
          {
            type: "selection",
            width: 60,
            align: "center",
          },
          {
            title: "日期",
            key: "out_time_date",
            align: "center",
            sortable: true,
            minWidth: 150,
          },
          {
            title: "提貨點",
            key: "ReceivingName",
            align: "center",
            sortable: true,
            minWidth: 130,
          },
          {
            title: "快遞數量",
            key: "count_goods",
            align: "center",
            sortable: true,
            minWidth: 130,
          },
          {
            title: "總代收費用",
            key: "sum_amount",
            align: "center",
            sortable: true,
            minWidth: 130,
          },
          {
            title: "總重量",
            key: "sum_weight",
            align: "center",
            minWidth: 160,
          },
        ],
        data: [],
      },
    };
  },
  created() {
    // this.getPickAddress();
  },
  methods: {
    onSelectionChange(data) {
      let totalNumber = 0,
        totalWeight = 0;
      for (const datum of data) {
        totalNumber += datum.count_goods;
        totalWeight += parseFloat(datum.sum_weight);
      }
      this.totalNumber = totalNumber;
      this.totalWeight = totalWeight.toFixed(2);
    },
    formatDate(datetime) {
      if (!datetime) return "";

      let dateTime = new Date(datetime);
      let year = dateTime.getFullYear();
      let month = dateTime.getMonth() + 1;
      let date = dateTime.getDate();
      let hour = dateTime.getHours();
      let minute = dateTime.getMinutes();
      let second = dateTime.getSeconds();
      let milliseconds = dateTime.getMilliseconds();
      return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(
        date
      )} ${this.formatNum(hour)}:${this.formatNum(second)}:${this.formatNum(
        milliseconds
      )}`;
    },
    formatNum(num) {
      return num < 10 ? "0" + num : num;
    },
    //提貨櫃點
    getPickAddress() {
      this.$Rq
        .requestAuth({
          url: this.$Api.pickAddress,
          method: "get",
          data: {
            company_id: 0,
          },
        })
        .then((res) => {
          if (res.code == 0) {
            this.pickAddress = res.data.data.filter(
              (it) => it.company_id != 15
            );
            if (res.data.data.length <= 1) {
              this.form.arrive = res.data.data[0].ReceivingID;
            }
          }
        });
    },
    handleExport() {
      let token = localStorage.getItem("jyb_token");
      let form = this.form;
      let params = {
        Authorization: token,
        start_time: this.formatDate(form.start_time),
        end_time: this.formatDate(form.end_time),
      };
      let formatParams = this.$Utils.formateObjToParamStr(params);
      // window.open(`${this.$Api.deliverFexport}?${formatParams}`, '_blank');

      if (form.start_time == "") {
        this.$Utils.showTipInfo("請選擇起始時間");
      } else {
        let a = document.createElement("a");
        a.href = `${this.$Api.exportDailyCountStoreNew}?${formatParams}`;
        a.click();
      }
    },
    getList() {
      let form = this.form;
      this.isSubmiting = true;
      let start_time = this.$Utils.formatDate(form.start_time);
      let end_time = this.$Utils.formatDate(form.end_time);
      this.$Rq
        .requestAuth({
          url: this.$Api.dailyCountStoreNew,
          method: "get",
          data: {
            // page: this.pageIndex,
            // size: this.curPageSize,
            // arrive: this.form.arrive,
            start_time,
            end_time: start_time == end_time ? "" : end_time,
          },
        })
        .then((res) => {
          this.isSubmiting = false;
          if (res.code == 0) {
            let tempArr = [];
            let resData = res.data.data;

            for (let i = 0; i < resData.length; i++) {
              tempArr.push({
                ReceivingName: resData[i].arriveName,
                count_goods: resData[i].nums,
                out_time_date: resData[i].date,
                sum_amount: resData[i].amount,
                sum_weight: Number(resData[i].weight).toFixed(2),
              });
            }

            this.totalCount = res.data.count;
            this.table.data = tempArr;
          }
        })
        .catch((err) => {
          this.isSubmiting = false;
        });
    },

    handleSearch() {
      if (this.form.start_time === "") {
        this.$Utils.showTipInfo("請輸入起始時間");
        return;
      }
      this.pageIndex = 1;
      this.getList();
    },

    //pager
    handlePageSizeChange(value) {
      this.pageIndex = 1;
      this.getList();
    },

    handlePageInput() {
      let value = ("" + this.pageInput).replace(/\D/g, "");
      let pageCount = Math.ceil(this.totalCount / this.curPageSize);
      if (value > pageCount) {
        value = pageCount;
      }
      this.pageInput = value;
    },
    handlePageEnter() {
      if (this.pageInput == "" || this.pageInput == this.pageIndex) return;
      if (this.pageInput == 0) {
        this.pageInput = 1;
      }
      this.pageInput = parseInt(this.pageInput);
      this.pageIndex = this.pageInput;
      this.getList();
    },

    handlePageChange(value) {
      this.pageIndex = value;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "dailyCountStore.scss";
</style>
